var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',{staticClass:"standby_lnfo"},[_c('v-card-text',[_c('p',[_vm._v(" 営業時間のご案内"),_c('br'),_vm._v(" "+_vm._s(_vm.businessDayTxt)),_c('br'),_vm._v(" "+_vm._s(_vm.businessHoursStart)+":00 - "+_vm._s(_vm.businessHoursEnd)+":00 ")]),_vm._v(" 現在："+_vm._s(_vm.hour)+"："+_vm._s(_vm.minute)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }